module.exports = __webpack_public_path__ + "static/media/ing.fe21edfe.svg";